import { render, staticRenderFns } from "./customerUpdate.vue?vue&type=template&id=03e28e42&scoped=true&"
import script from "./customerUpdate.vue?vue&type=script&lang=js&"
export * from "./customerUpdate.vue?vue&type=script&lang=js&"
import style0 from "./customerUpdate.vue?vue&type=style&index=0&id=03e28e42&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e28e42",
  null
  
)

export default component.exports